module.exports = __webpack_public_path__ + "static/coca-cola-bg-122a62478292f6f08ed091f2c3b8f5e2.png";